import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "p-floating-give-point-button__label" }
const _hoisted_3 = { "data-translate-skip": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCancel = _resolveComponent("IconCancel")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconPresent = _resolveComponent("IconPresent")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "p-floating-give-point-button",
        style: _normalizeStyle({ '--site-color': _ctx.colorCode })
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "p-floating-give-point-button__close",
          "aria-label": "閉じる",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createVNode(_component_IconBase, {
            width: 16,
            height: 16,
            "view-box": "0 0 16 16",
            "icon-name": "閉じる"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconCancel)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("a", {
          href: _ctx.url,
          class: "p-floating-give-point-button__link"
        }, [
          _createVNode(_component_IconBase, {
            class: "p-floating-give-point-button__icon",
            width: 20,
            height: 20,
            "view-box": "3 4 18 17",
            "icon-name": "ポイントを贈る"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconPresent)
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.pointName), 1),
            _cache[1] || (_cache[1] = _createTextVNode("を贈る ", -1))
          ])
        ], 8, _hoisted_1)
      ], 4))
    : _createCommentVNode("", true)
}